// extracted by mini-css-extract-plugin
export default {"loading_spinner":"LoadingSpinner_loading_spinner__ojfCA","spinner":"LoadingSpinner_spinner__+PytG","spinner_container":"LoadingSpinner_spinner_container__+mshE"};